export const LOCAL_STORAGE_KEY = 'first-point';
export const SESSION_STORAGE_KEY = 'session-point';

export const PHONE = '+1 989-980-8185';
export const EMAIL = 'n.troxell@andersenlab.com';

export const MEETUP_DATE = '2025-11-18';
export const MEETUP_TIME = '7:30 AM, CST';
